import { render } from "./LearningResource.vue?vue&type=template&id=27151aa6&scoped=true"
import script from "./LearningResource.vue?vue&type=script&lang=js"
export * from "./LearningResource.vue?vue&type=script&lang=js"

import "./LearningResource.vue?vue&type=style&index=0&id=27151aa6&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27151aa6"]])

export default __exports__